import './index.less'
import { message, Select } from 'antd'
import { emptyStar, fillStar } from '@/assets/images'
import map1 from '@/assets/data/平水韵.json'
import map2 from '@/assets/data/韵母2声调.json'
import React, { useEffect, useState } from 'react'
import Cell from './Cell'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { setWordAnimationObj } from '@/features/SetWordAnimationObj/setWordAnimationObj'
import {
  Emotion,
  Rhyme,
  Rhythm,
  scoreI,
  setEmotionSelected,
  setPoem as _setPoem,
  setRhythmSelected,
  setScentenceSelected
} from '@/features/SetPoemInfo/setPoemInfo'
import { getPoem } from '@/server'

//创作生成
export function GenerationPage() {
  const token = useAppSelector((state) => state.login.token)
  // 诗相关信息
  // 诗
  const [poem, setPoem] = useState<string[][]>([])
  // 历史选择句式
  const sentenceSelected: Rhyme = useAppSelector((state) => state.poemInfo.scentenceSelected)
  // 历史选择情绪
  const emotionSelected: Emotion = useAppSelector((state) => state.poemInfo.emotionSelected)
  // 历史选择韵律
  const rhythmSelected: Rhythm = useAppSelector((state) => state.poemInfo.rhythmSelected)
  // 评分
  const _score: scoreI = useAppSelector((state) => state.poemInfo.score)
  // 诗的挂载动画对象
  const wordAnimationObj = useAppSelector((state) => state.wordAnimation.wordAnimation)
  const dispatch = useAppDispatch()
  // 句式（用于选择）
  const [systemSentenceSelected, setSystemSentenceSelected] = useState<Rhyme>(sentenceSelected)
  // 情感（用于选择）
  const [systemEmotionSelected, setSystemEmotionSelected] = useState<Emotion>(emotionSelected)
  // 韵律（用于选择）
  const [systemRhythmSelected, setSystemRhythmSelected] = useState<Rhythm>(rhythmSelected)
  // Select菜单
  const emotionOptions = [
    {
      value: 'objective',
      label: '积  极'
    },
    {
      value: 'neutral',
      label: '中  立'
    },
    {
      value: 'negative',
      label: '消  极'
    }
  ]
  const emotionOptionsDefault = emotionSelected
  const sentenceOptions = [
    {
      value: Rhyme.FIVE_WORD,
      label: '五  言'
    },
    {
      value: Rhyme.SEVEN_WORD,
      label: '七  言'
    }
  ]
  const sentenceOptionsDefault = sentenceSelected
  const rhythmOptions = [
    {
      value: 'flat',
      label: '平起式'
    },
    {
      value: 'oblique',
      label: '仄起式'
    }
  ]
  const rhythmOptionsDefault = rhythmSelected

  // 用户评分[连贯,情感,韵律]
  const [pointArr, setPointArr] = useState<number[]>([0, 0, 0])
  // 生成按钮是否可用
  const [abled, setAbled] = useState<boolean>(true)
  // 诗的挂载动画
  const customCellMounted = () => {
    const cur_idx = wordAnimationObj.cur_idx
    setTimeout(() => {
      dispatch(
        setWordAnimationObj({
          show_brush: true,
          fade: true,
          cur_idx: cur_idx + 1
        })
      )
    }, 500)
  }
  /**
   * 选择句式的回调
   * @param value：选择的内容
   */
  const handleSelectSentenceOptions = function (value) {
    setSystemSentenceSelected(value)
  }
  /**
   * 选择情感的回调
   * @param value
   */
  const handleEmotionOptions = function (value) {
    setSystemEmotionSelected(value)
  }
  /**
   * 选择韵律的回调
   * @param value：选择的内容
   */
  const handleSystemRhythmSelected = function (value) {
    setSystemRhythmSelected(value)
  }
  /**
   * 用户评分的回调
   * @param type: 连贯(0)/情感(1)/韵律(2)
   * @param index: 点击star的索引
   */
  const handleClickStar = function (type: number, index: number) {
    setPointArr(
      pointArr.map((point, i) => {
        if (type === i) return index + 1
        else return point
      })
    )
  }
  /**
   * 获得rhyme参数
   * @returns 0(七言平起), 1(七言仄起), 2(五言平起), 3(五言仄起)
   */
  const getRhyme = function () {
    if (systemSentenceSelected === Rhyme.SEVEN_WORD)
      if (systemRhythmSelected === Rhythm.FLAT)
        //七言平起
        return 0
      //七言仄起
      else return 1
    //五言平起
    else if (systemRhythmSelected === Rhythm.FLAT) return 2
    //五言仄起
    else return 3
  }
  // 生成按钮的回调
  const handleGetPoem = async () => {
    if (!abled) {
      message.warning('别急，诗句正在生成中...')
      return
    }
    dispatch(
      setWordAnimationObj({
        show_brush: false,
        fade: false,
        cur_idx: -1
      })
    )
    // 现代文句子
    const caption =
      '秋风萧瑟吹落枝头枯黄的叶子，小舟在江中漂流，我在桥上眺望着远处的群山，想起了我的故友'
    // 情绪分数
    const emotion =
      systemEmotionSelected === Emotion.OBJECTIVE
        ? 5
        : systemEmotionSelected === Emotion.NEGATIVE
          ? 1
          : 3
    const rhyme = getRhyme()
    getPoem(
      { caption: caption, emotion: emotion, rhyme: rhyme, yun: rhyme === 3 ? 19 : 25 },
      token
    ).then((res) => {
      const newPoem: string[][] = []
      for (let i = 0; i < res.data.poetry.length; i++) {
        newPoem.push(res.data.poetry[i].split(''))
      }
      // dispatch(setPoem(newPoem))
      setPoem(newPoem)
    })
    // 记录选择内容
    dispatch(setScentenceSelected(systemSentenceSelected))
    dispatch(setEmotionSelected(systemEmotionSelected))
    dispatch(setRhythmSelected(systemRhythmSelected))
    dispatch(
      setWordAnimationObj({
        show_brush: true,
        fade: true,
        cur_idx: 0
      })
    )
    setAbled(false)
  }
  // 提交按钮的回调
  const handleSubmitPoem = function () {
    console.log('提交')
  }
  /**
   * 计算韵律
   * @param word：字
   * @returns 对应韵律
   */
  const computeRhythm = (word: string) => {
    if (!word) return
    // 1. word在map1的value里面
    const map1Values = Object.values(map1)
    // 2. 找出value对应的key
    const map1Keys = Object.keys(map1)
    const map1Key = (
      map1Keys[map1Values.findIndex((values) => values.split('').includes(word))] as string
    ).slice(-3, -2)

    return (map2 as any)[map1Key]
  }

  // 获取物象数组
  const [currentFormTags, setCurrentFormTags] = useState<string[]>([])
  const formLocalInfo = useAppSelector((state) => state.sixLawsInfo.localInfo)
  useEffect(() => {
    const newCurrentTags: string[] = []
    for (let i = 0; i < formLocalInfo.length; i++) {
      const wuxiangTags = formLocalInfo[i].tags.filter((item) => item.typeName === '物象')
      if (wuxiangTags.length > 0) {
        for (let j = 0; j < wuxiangTags[0].tags.length; j++) {
          if (!newCurrentTags.includes(wuxiangTags[0].tags[j])) {
            newCurrentTags.push(wuxiangTags[0].tags[j])
          }
        }
      }
    }
    setCurrentFormTags(newCurrentTags)
  }, [formLocalInfo])
  return (
    <div className='generation-page-container'>
      <div className='generation-select-area'>
        {/* 下拉选项 */}
        <div className='first-line'>
          <div className='select-item'>
            <div className='select-text'>情 感</div>
            <Select
              defaultValue={emotionOptionsDefault}
              options={emotionOptions}
              onSelect={handleEmotionOptions}
            />
          </div>
          <div className='select-item'>
            <div className='select-text'>句 式</div>
            <Select
              defaultValue={sentenceOptionsDefault}
              options={sentenceOptions}
              onSelect={handleSelectSentenceOptions}
            />
          </div>
          <div className='select-item'>
            <div className='select-text'>韵 律</div>
            <Select
              defaultValue={rhythmOptionsDefault}
              options={rhythmOptions}
              onSelect={handleSystemRhythmSelected}
            />
          </div>
        </div>
        <div className='second-line'>
          <div className='second-text'>物象</div>
          <div className='second-show'>
            {currentFormTags.map((item) => (
              <div className='second-item'>{item}</div>
            ))}
          </div>
        </div>
      </div>
      <div className='generation-show-area'>
        {/* 诗 */}
        <div className='poem-show'>
          {poem.map((group: string[], groupIndex: number) => {
            return (
              <div className='poem-row' key={groupIndex}>
                <div className='row'>
                  {group.map((item, columnIndex: number) =>
                    wordAnimationObj.cur_idx >= groupIndex * sentenceSelected + columnIndex ? (
                      <Cell
                        word={item}
                        rhythm={computeRhythm(item)}
                        key={columnIndex}
                        setAbled={setAbled}
                        abled={abled}
                        mounted={customCellMounted}
                      />
                    ) : null
                  )}
                  <svg className='svg'>
                    <g className='gBrush' id={`brush${groupIndex}`}></g>
                  </svg>
                </div>
              </div>
            )
          })}
        </div>
        {/* 评分 */}
        <div className='point-show'>
          <div className='point-content'>
            <div className='point-title'>连贯</div>
            <div className='point-star'>
              {Array(5)
                .fill(0)
                .map((_item, index) => {
                  return (
                    <img
                      src={pointArr[0] > index ? fillStar : emptyStar}
                      alt='fill-star'
                      onClick={() => handleClickStar(0, index)}
                    />
                  )
                })}
            </div>
          </div>
          <div className='point-content'>
            <div className='point-title'>情感</div>
            <div className='point-star'>
              {Array(5)
                .fill(0)
                .map((_item, index) => {
                  return (
                    <img
                      src={pointArr[1] > index ? fillStar : emptyStar}
                      alt='fill-star'
                      onClick={() => handleClickStar(1, index)}
                    />
                  )
                })}
            </div>
          </div>
          <div className='point-content'>
            <div className='point-title'>韵律</div>
            <div className='point-star'>
              {Array(5)
                .fill(0)
                .map((_item, index) => {
                  return (
                    <img
                      src={pointArr[2] > index ? fillStar : emptyStar}
                      alt='fill-star'
                      onClick={() => handleClickStar(2, index)}
                    />
                  )
                })}
            </div>
          </div>
        </div>
        <div className='operate-area'>
          <div className='operate-btn' onClick={handleGetPoem}>
            生&nbsp;&nbsp;&nbsp;成
          </div>
          <div className='operate-btn' onClick={handleSubmitPoem}>
            提&nbsp;&nbsp;&nbsp;交
          </div>
        </div>
      </div>
    </div>
  )
}
